import React, { useState } from 'react';
import GenericButton from '../components/GenericButton';
import GenericInput from '../components/GenericInput'; // Import the GenericInput component
import GenericInputWithEye from '../components/GenericInputWithEye';
import { User } from '../models/Users';

interface AddUserPageProps {
  onSave: (value: any) => void;  // Save callback function
  data: User;  // Game data for editing, possibly null if creating a new user
}

const AddUserPage: React.FC<AddUserPageProps> = ({ onSave, data }) => {
  const [user, setUser] = useState<User>(data);

  // Form error state
  const [errors, setErrors] = useState({
    name: '',
    mobile: '',
    password: '',
    commissionRate: ''
  });

  // Validation functions
  const validateName = (value: string) => {
    return value?.trim() === '' ? 'Name is required' : '';
  };

  const validatePhone = (value: string) => {
    const phonePattern = /^[0-9]{10}$/; // Simple validation for 10 digits
    return value.trim() === '' ? 'Phone number is required' :
      !phonePattern.test(value) ? 'Phone number must be 10 digits' : '';
  };

  const validatePassword = (value: string) => {
    const phonePattern = /^[0-9]{6}$/; // Simple validation for 10 digits
    return value.trim() !== '' && !phonePattern.test(value) ? 'Password must be 6 digits' : '';
  };

  const validateCommissionRate = (value: string) => {
    const numberPattern = /^[0-9]+(\.[0-9]+)?$/;
    return value !== '' && !numberPattern.test(value)
      ? 'Please enter a valid Rate (e.g., 7, 1.2, 6.9)'
      : '';
  };

  const handleSubmit = () => {

    if (!user || !user?.name || !user.mobile || !user.password || !user.commissionRate) {
      return;
    }
    // Validate the form
    const nameError = validateName(user.name);
    const phoneError = validatePhone(user.mobile);
    const passwordError = validatePassword(user.password);
    const commissionRate = validateCommissionRate(user.commissionRate);

    if (nameError || phoneError || passwordError || commissionRate) {
      setErrors({ name: nameError, mobile: phoneError, password: passwordError, commissionRate: commissionRate });
      return; // Prevent form submission if there are validation errors
    }

    // If validation passes, trigger the onSave function with the updated user data
    onSave(user);
  };

  return (
    <div className="container mt-4">
      <div className="mb-3">
        <GenericInput
          label="Name"
          value={user.name}
          onChange={(e) => setUser({ ...user, name: e })}
        />
        {errors.name && <div className="invalid-feedback d-block">{errors.name}</div>}
      </div>

      <div className="mb-3">
        <GenericInput
          label="Phone"
          value={user.mobile}
          onChange={(e) => setUser({ ...user, mobile: e })}
          type="text"
        />
        {errors.mobile && <div className="invalid-feedback d-block">{errors.mobile}</div>}
      </div>

      <div className="mb-3">
        <GenericInputWithEye
          label="Password"
          value={user.password}
          onChange={(e) => setUser({ ...user, password: e })}
          type="password"
        />
        {errors.password && <div className="invalid-feedback d-block">{errors.password}</div>}
      </div>

      <div className="mb-3">
        <GenericInput
          label="Commission Rate"
          value={user.commissionRate}
          onChange={(e) => setUser({ ...user, commissionRate: e })}
          type="text"
        />
        {errors.commissionRate && <div className="invalid-feedback d-block">{errors.commissionRate}</div>}
      </div>



      <GenericButton label={data?.id ? 'Update User' : 'Add User'} onClick={handleSubmit} />
    </div>
  );
};

export default AddUserPage;
